import './style.scss';
import PcItem from '../../PcItem/PcItem';
import Tarifs from '../../Tarifs/Tarifs';
import floorMap, { zoneLabels, subLabels } from './floorMap';

const Floor = ({ psList }) => {
    const placed = psList.filter((pc) => floorMap[pc.number]);

    // Для телефонов: те же ПК, сгруппированные по рядам плана зала
    const rowsMap = {};
    placed.forEach((pc) => {
        const [row, col] = floorMap[pc.number];
        (rowsMap[row] = rowsMap[row] || []).push({ pc, col });
    });
    const mobileRows = Object.keys(rowsMap)
        .map(Number)
        .sort((a, b) => a - b)
        .map((row) => rowsMap[row].sort((a, b) => a.col - b.col).map((item) => item.pc));

    return (
        <>
        <div className="floorList">
            {mobileRows.map((pcs, i) => (
                <div key={i} className="floorList-row">
                    <div className="floorList-title">Ряд {i + 1}</div>
                    <div className="floorList-items">
                        {pcs.map((pc) => (
                            <PcItem key={pc.number} pc={pc} />
                        ))}
                    </div>
                </div>
            ))}
            <div className="floorList-price">
                <Tarifs />
            </div>
        </div>

        <div className="floorGrid">
            {zoneLabels.map((zone) => (
                <div
                    key={zone.name}
                    className={`zoneLabel ${zone.className}`}
                    style={{ gridRow: zone.row, gridColumn: `${zone.colStart} / ${zone.colEnd}` }}
                >
                    {zone.name}
                </div>
            ))}

            {subLabels.map((label) => (
                <div
                    key={label.name}
                    className="subLabel"
                    style={{ gridRow: label.row, gridColumn: `${label.colStart} / ${label.colEnd}` }}
                >
                    {label.name}
                </div>
            ))}

            {placed.map((pc) => {
                const [row, col] = floorMap[pc.number];

                return (
                    <div key={pc.number} style={{ gridRow: row, gridColumn: col }}>
                        <PcItem pc={pc} />
                    </div>
                );
            })}

            <div className="priceListSlot">
                <Tarifs />
            </div>
        </div>
        </>
    );
};

export default Floor;
